import type {InputHTMLAttributes, ReactNode} from "react";

export type DsInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  hint?: string;
  error?: string;
};

export function DsInput({label, hint, error, className, id, ...props}: DsInputProps) {
  const inputId = id || (label ? `ds-input-${label.replace(/\s+/g, "-").toLowerCase()}` : undefined);
  const inputCls = ["cc-ds-input", error ? "cc-ds-input--error" : "", className || ""].filter(Boolean).join(" ");

  const field = (
    <input id={inputId} className={inputCls} aria-invalid={error ? true : undefined} {...props} />
  );

  if(!label && !hint && !error) return field;

  return (
    <div className="cc-ds-field">
      {label ? <label className="cc-ds-field__label" htmlFor={inputId}>{label}</label> : null}
      {field}
      {error ? <span className="cc-ds-field__error" role="alert">{error}</span> : null}
      {!error && hint ? <span className="cc-ds-field__hint">{hint}</span> : null}
    </div>
  );
}

export type DsFieldProps = {
  label?: string;
  hint?: string;
  error?: string;
  children: ReactNode;
};

export function DsField({label, hint, error, children}: DsFieldProps) {
  return (
    <div className="cc-ds-field">
      {label ? <span className="cc-ds-field__label">{label}</span> : null}
      {children}
      {error ? <span className="cc-ds-field__error" role="alert">{error}</span> : null}
      {!error && hint ? <span className="cc-ds-field__hint">{hint}</span> : null}
    </div>
  );
}
